import JournalMenu from "@/src/_types/JournalMenu";
import MenuItem from "@/src/_types/menu-item";

export const mapToMenuItems = (
  menu: JournalMenu[],
  journal: Journal,
): MenuItem[] => {
  return (
    menu?.map((item: any) => ({
      icon: item.iconfa || "",
      label: item.title,
      link: item.url,
      children: item.children
        ? mapToMenuItems(item.children, journal)
        : undefined,
    })) || []
  );
};
